import { useQuery } from '@tanstack/react-query';

import { RequestConfig } from '~/common/services/requests/types/RequestConfig';
import { SignatureService } from '../../../../types';
import { useRequestConstructor } from '../../../hooks/useRequestConstructor';
import { NonPaginatedResponse } from '../../../types/NonPaginatedResponse';
import { SIGNATURE_BASE_PATH } from '../../constants/signatureBasePath';
import { getSignatureService } from '../../requests/getSignatureService';

export const useSignatureService = (
  identifier: string,
  params?: RequestConfig['params'],
  options?: { enabled?: boolean },
) => {
  const { constructGet } = useRequestConstructor();

  const { data, ...rest } = useQuery<
    NonPaginatedResponse<SignatureService> | undefined
  >({
    queryKey: [SIGNATURE_BASE_PATH, 'services', identifier, params],
    queryFn: () => getSignatureService(constructGet, identifier, params),
    staleTime: 30000,
    ...options,
  });

  return { service: data?.data, ...rest };
};
